// Module
var code = `<app-page-content [show-web-footer]="true" [use-page-padding]="true">
    <h4>TEST ALERTS</h4>
</app-page-content>`;
// Exports
module.exports = code;